import React from 'react';
import SvgIcon from './SvgIcon';

const EyeCancel = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M16.53 6.5c-1.36-.636-2.885-1.063-4.53-1.063C5.55 5.438.937 12 .937 12s2.429 3.455 6.225 5.35m11.694-9.48C21.473 9.74 23.062 12 23.062 12S18.45 18.563 12 18.563a9.815 9.815 0 01-2-.209"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.65 14.735a3.75 3.75 0 114.85-5.718m1.237 2.483a3.75 3.75 0 01-3.405 4.048"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.12 11.313a.5.5 0 10-.865-.5l.866.5zm-.865-.5a2 2 0 00-.268 1.004l1-.002a1 1 0 01.134-.502l-.866-.5zm-.268 1.004a2 2 0 00.272 1.003l.864-.504a1 1 0 01-.136-.501l-1 .002zm.272 1.003a2 2 0 00.74.731l.494-.87a1 1 0 01-.37-.365l-.864.504z"
                fill="currentColor"
            />
            <path stroke="currentColor" strokeLinecap="round" d="M19.062 3.704L4.278 21.323" />
        </SvgIcon>
    );
};

EyeCancel.displayName = 'EyeCancelIcon';

export default EyeCancel;
